import { removeCookie, getValueCookie } from "../services/cookieService"
import { OpenLogin } from "./pagesFunction"
import { v4 as uuidv4 } from 'uuid';

export const closeSession = async () => {
    // Validar remember me
    const rememberMe = getValueCookie('rememberMe')
    if (!rememberMe) {
        removeCookie('usernameInput')
    }
    
    // Limpiar cookies
    removeCookie('userName')
    removeCookie('name')
    removeCookie('surname')
    removeCookie('SubCompanyId')
    removeCookie('sessionAuthToken')
    removeCookie('sessionAuthToken')
    removeCookie('Company')
    removeCookie('phone')
    removeCookie('warehouse')
    removeCookie('website')
    removeCookie('address')
    removeCookie('fullName')
    removeCookie('TypeUser')
    removeCookie('SalesPerson')
    removeCookie('DocumentsLogo')
    removeCookie('CompanyLogo')
    removeCookie('CompanyId')
    removeCookie('TotalOrders')

    window.localStorage.setItem('session', uuidv4())
    window.localStorage.removeItem('SalesOrderSave')
    window.localStorage.removeItem('selectedCustomer')
    
    // Redirigir a login
    OpenLogin()
}

export default {closeSession}